// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8587) return "static/css/8587.9f8993f55da7ad7a20c0.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1865":"ea9798e5fd931e89d597","4952":"468f0f7a52b076b70ff5"}[chunkId] + ".chunk.css";
};